import {
  createRootRoute,
  type NavigateOptions,
  Outlet,
  type ToOptions,
  useRouter,
} from "@tanstack/react-router";
import { RouterProvider } from "react-aria-components";

import { NotFound } from "@/components/NotFound";

declare module "react-aria-components" {
  interface RouterConfig {
    href: ToOptions;
    routerOptions: Omit<NavigateOptions, keyof ToOptions>;
  }
}

export const Route = createRootRoute({
  notFoundComponent: NotFound,
  component: RootRoute,
});

function RootRoute() {
  const router = useRouter();
  return (
    <RouterProvider
      navigate={(to, options) => router.navigate({ ...to, ...options })}
      useHref={(to) => {
        if (to && typeof to !== "string") {
          return router.buildLocation(to).href;
        }
        return "";
      }}
    >
      <Outlet />
    </RouterProvider>
  );
}
